import SimcardProfile from './simcard-profile'
import EsimProfile from './simcard-profile-esim'
import SimServer from "./sim-server"
import MnoApi from "./mno-api"

export default {
  ...SimcardProfile,
  ...EsimProfile,
  ...SimServer,
  ...MnoApi
}
